import Vue from 'vue'
import Vuex from 'vuex'

import app from '../../base/modules/app'
import myself from './myself'
import history from './history'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    myself,
    history
  }
})
